import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silenciar el warning benigno de ResizeObserver (Radix Select) que en preview
// dispara el overlay rojo de webpack-dev-server y bloquea la interacción.
const swallowResizeObserver = (e) => {
  if (e?.message && /ResizeObserver loop/.test(e.message)) {
    e.stopImmediatePropagation();
  }
};
window.addEventListener("error", swallowResizeObserver);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
